import React, { useState, useMemo, useRef, useImperativeHandle, forwardRef } from 'react';
import { Popup } from 'devextreme-react/popup';
import { FormRef } from 'devextreme-react/form';
import 'devextreme-react/text-area';

import CustomerApiCredentialApi from '../../api/CustomerApiCredentialApi';


import TokenBox from './TokenBox';

interface PathCredentialShowFormProps {
    
}

export interface PathCredentialShowFormHandle {
    Open: (id: number) => void;
}

const PathCredentialShowForm = forwardRef<PathCredentialShowFormHandle, PathCredentialShowFormProps>(({}, ref) => {

    const formRef = useRef<FormRef>(null);

    const [isOpen, setIsOpen] = useState(false);

    const [personalAccessToken, setPersonalAccessToken] = useState("");

    useImperativeHandle(ref, () => ({
        Open(id: number) {
            CustomerApiCredentialApi.GetPersonalAccessTokenAsync(id)
                .then((e) => {
                    if (formRef.current !== null) {
                        const formInstance = formRef.current.instance();
                        formInstance.clear();
                    }
                    setIsOpen(true);
                    setPersonalAccessToken(e.Result);
                });
        }
    }));

    const closeDialog = () => {
        setIsOpen(false);
    };

    const popupAttributes = useMemo(() => {
        return {
            id: 'elementId',
            class: 'class-name-popup'
        }
    }, []);

    return (
        <React.Fragment>
            <Popup
                wrapperAttr={popupAttributes}
                visible={isOpen}
                onHiding={closeDialog}
                dragEnabled={false}
                hideOnOutsideClick={false}
                showCloseButton={true}
                showTitle={true}
                title="Personal access token"
                container=".dx-viewport"
                width={600}
                height={200}
            >
                <div style={{ width: '100%' }} >
                    <TokenBox Token={personalAccessToken} />
                </div>
            </Popup>
        </React.Fragment>
    );
});

export default PathCredentialShowForm;